export default __webpack_public_path__ + "static/media/skills.2a83074c.less";